import { Component } from 'react'

import { Search } from './Search'
import { Taxonomies } from './Taxonomies'

export class FilterBarModal extends Component {

    constructor(props) {
        super(props)

        this.resetAndClose = this.resetAndClose.bind( this )
    }

    resetAndClose() {
        this.props.resetFilters()
        this.props.closeModal()
    }

	render() {
        if ( this.props.isOpen ) {
            return (
                <div className="pf-filter-bar-modal">
                    <div className="pf-filter-bar-modal__top">
                        <button className="icon-close pf-filter-bar-modal__close" onClick={ this.props.closeModal }></button>

                        <div className="pf-filter-bar-modal__title">Filter by</div>

                        <div className="pf-filter-bar-modal__reset" onClick={ this.resetAndClose }>Clear</div>
                    </div>

                    <Taxonomies 
                        taxonomies={ this.props.taxonomies } 
                        filters={ this.props.filters } 
                        updateFilter={ this.props.updateFilter } 
                        showTaxList={ false }
                    />

                    <div className="pf-filter-bar-modal__cta">
                        <button className="pf-filter-bar-modal__cta-btn" onClick={ this.props.closeModal }>Show Results</button>
                    </div>
                </div>
            )
        } else {
            return '';
        }
	}

}